import React from "react";
import { Link } from "react-router-dom";

const DeliveryOne = () => {
  return (
    <section
      style={{
        width: "100%",
        overflow: "hidden"
      }}
    >
      <div
        className="container"
        style={{
          maxWidth: "100%"
        }}
      >
        <div
          style={{
            position: "relative",
            overflow: "hidden", // 👈 KILLS horizontal overflow
            borderRadius: "16px",
            padding: "16px",
            backgroundColor: "rgba(255, 0, 0, 0.68)" // semi-transparent background
          }}
        >
          {/* Background Image */}
          <img
            src="assets/images/bg/delivery-bg.png"
            alt=""
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover", // 👈 prevents bleed
              zIndex: -1
            }}
          />

          <div className="row align-items-center position-relative">
            <div className="col-md-3 d-md-block d-none">
              <div style={{ textAlign: "center" }}>
                <img
                  src="assets/images/thumbs/delivery.png"
                  alt=""
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    display: "block"
                  }}
                />
              </div>
            </div>

            <div className="col-md-5 col-sm-7">
              <div style={{ textAlign: "center" }}>
                <h4 style={{ color: "#fff", marginBottom: "8px" }}>
                  Discover Our Latest Arrivals This Week
                </h4>
                <p style={{ color: "#fff" }}>
                  Fresh styles, new collections, and exclusive products just landed.
                </p>

                <Link
                  to="/shop"
                  style={{
                    marginTop: "16px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "10px 16px",
                    borderRadius: "999px",
                    textDecoration: "none",
                         backgroundColor: "#fff",
                  }}
                >
                  Shop Now
                  <span
                    style={{
                      display: "flex",
                      fontSize: "18px",
                 
                    }}
                  >
                    <i className="ph ph-arrow-right" />
                  </span>
                </Link>
              </div>
            </div>

            <div
              className="col-md-4 col-sm-5 d-sm-block d-none"
              style={{ textAlign: "center" }}
            >
              <img
                src="assets/images/thumbs/car.png"
                alt=""
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  display: "block"
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DeliveryOne;
